<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        },
        pagination: {
          el: '.swiper-pagination'
        },

      }
    }
  },
}
</script>

<template>
  <div class="pulmonology">
    <!--    <section class="section section1">-->
    <!--      <h2>Пульмонологія </h2>-->

    <!--      <img class="mob" src="@/assets/img/pulmonology/banner-mob.png" alt="banner">-->
    <!--    </section>-->

    <div class="pulmonology__banner">
      <div class="pulmonology__wrapper container">
        <div class="left">
          <h1 class="pulmonology__banner--title">Пульмонологія</h1>
        </div>
        <div class="right">
          <img class="img-desc" src="@/assets/img/pulmonology/banner.svg">
          <img class="img-mob" src="@/assets/img/pulmonology/banner-mob.svg">
        </div>
      </div>
    </div>

    <section class="section section2">
      <div class="container">
        <div class="section2__col section2__col--first">
          <h3>Дія програми «ТерапіяПЛЮС»<br> для&nbsp;пацієнтів із хронічним обструктивним захворюванням
            легень<br><span> поширюється на:</span>
          </h3>
          <div class="section2__iconText">
            <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_60_882)">
                <circle cx="48" cy="48" r="47.5" stroke="#3C1053"/>
              </g>
              <circle cx="48" cy="48" r="42.5" fill="#FFD770" stroke="#3C1053"/>
              <path
                d="M50.2149 67.3312L24.5365 45.457C24.2148 45.1829 24.1001 44.7362 24.2499 44.3411L28.9727 31.8903C29.2246 31.2263 30.0689 31.0291 30.5888 31.5128L50.3174 49.8651C50.7019 50.2227 51.2975 50.2221 51.6812 49.8636L87.3173 16.572C87.9564 15.9749 89 16.4281 89 17.3027V20.1492C89 20.3763 88.9227 20.5966 88.7809 20.7739L51.6443 67.1947C51.2917 67.6354 50.6445 67.6972 50.2149 67.3312Z"
                fill="white" stroke="#3C1053"/>
              <defs>
                <clipPath id="clip0_60_882">
                  <rect width="48" height="96" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <p class="section2__text1">оригінальний* лікарський засіб компанії
              <svg width="140" height="34" viewBox="0 0 140 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.45538 27.2851L6.76022 21.0156L8.95576 27.2851H4.45538ZM11.1931 33.6028H13.3051L7.82423 18.5137H5.73477L0 33.6028H2.13125L3.81568 28.9756H9.55688L11.1931 33.6028ZM21.2193 30.4053C21.2193 31.6353 20.2228 32.289 18.5223 32.289C17.1497 32.289 16.2271 31.9026 15.716 31.0139L13.6844 31.3713C14.4752 32.9942 16.121 33.767 18.4387 33.767C21.5858 33.767 23.2316 32.0217 23.2316 30.1606C23.2316 27.7713 21.0329 27.1241 18.4998 26.6121C17.2782 26.3673 15.8446 25.9133 15.8446 24.8282C15.8446 24.0554 16.5968 23.1634 18.1044 23.1634C19.6442 23.1634 20.5635 24.2131 20.705 24.6285L22.489 23.8847C21.6725 22.323 20.0363 21.6854 18.323 21.6854C15.6742 21.6854 13.9222 22.9927 13.9222 25.0697C13.9222 27.4332 15.9442 27.8969 17.9019 28.3219C19.5863 28.689 21.2193 29.1044 21.2193 30.4053ZM27.4491 18.5137L25.4689 19.3412V22.1266H23.6527V23.7301H25.4689V31.0976C25.4432 32.5949 25.4432 33.6768 27.6677 33.6768C28.3974 33.6768 29.1914 33.5319 29.5289 33.4836V31.8962C29.1432 32.0153 28.6353 32.1602 28.272 32.1602C27.4491 32.1602 27.4491 31.5806 27.4491 30.225V23.7301H29.5289V22.1266H27.4491V18.5137ZM31.2648 22.1266V33.5996H33.1839V28.3251C33.1839 27.343 33.1582 26.1774 33.6693 25.3466C34.2929 24.3291 35.2187 23.9427 37.1024 23.9266V21.9398C36.3277 21.9656 34.2736 22.0139 33.1839 24.1777V22.1266H31.2648ZM48.4755 18.5169V20.3749H57.0359L48.4691 31.6386V33.5996H59.5336V31.7899H50.7964L59.3182 20.3974V18.5169H48.4755ZM71.5753 22.1266V33.5996H73.4977V27.0951C73.4977 26.245 73.4977 25.3756 74.3495 24.5287C74.9571 23.9266 75.6868 23.6593 76.5354 23.6593C77.5801 23.6593 78.6506 24.1423 78.9881 25.2339C79.1135 25.6171 79.1135 25.9584 79.1135 27.1208V33.606H81.0294V26.8021C81.0294 25.8328 81.0294 25.1341 80.8333 24.4546C80.2772 22.5645 78.5316 21.8303 77.069 21.8303C76.3907 21.8303 74.5681 22.001 73.4977 23.8718V22.1266H71.5753ZM101.423 30.8239C101.021 31.6096 100.265 32.3244 98.7802 32.3244C97.4879 32.3244 95.3181 31.5098 95.3181 27.7262C95.3181 26.7087 95.5013 23.1054 98.658 23.1054C100.252 23.1054 100.989 23.9749 101.329 24.7283L103.129 23.9749C102.02 22.1266 100.021 21.6951 98.5905 21.6951C94.942 21.6951 93.1804 24.6317 93.1804 27.8743C93.1804 30.679 94.7073 33.8024 98.7544 33.8024C101.098 33.8024 102.406 32.6657 103.117 31.5387L101.423 30.8239ZM62.2949 26.6733H68.364C68.1936 23.6754 66.4674 23.1666 65.3166 23.1666C63.674 23.1634 62.5103 24.3741 62.2949 26.6733ZM69.9488 31.4035C69.293 32.5208 68.0265 33.7992 65.5384 33.7992C62.1567 33.7992 60.2087 31.4969 60.2087 27.6393C60.2087 23.3341 63.0503 21.6854 65.4645 21.6854C67.5636 21.6854 69.5791 22.8478 70.2574 25.7266C70.4727 26.6958 70.4727 27.5684 70.4727 28.0514H62.2531C62.2017 29.9674 63.0053 32.392 65.712 32.347C66.8146 32.3276 67.5925 31.8253 68.0875 31.0396L69.9488 31.4035ZM84.1378 26.6733H90.2069C90.0365 23.6754 88.3103 23.1666 87.1595 23.1666C85.5201 23.1634 84.3564 24.3741 84.1378 26.6733ZM91.7917 31.4035C91.1359 32.5208 89.8694 33.7992 87.3749 33.7992C83.9964 33.7992 82.0548 31.4969 82.0548 27.6393C82.0548 23.3341 84.89 21.6854 87.3042 21.6854C89.4065 21.6854 91.4188 22.8478 92.0971 25.7266C92.3125 26.6958 92.3125 27.5684 92.3125 28.0514H84.0896C84.0414 29.9674 84.845 32.392 87.5485 32.347C88.6543 32.3276 89.4322 31.8253 89.9273 31.0396L91.7917 31.4035ZM113.625 33.6028L111.622 33.6124C111.622 33.6124 111.449 32.801 111.394 31.9187C110.815 32.5208 109.739 33.7702 107.562 33.7702C105.338 33.7702 103.689 32.4468 103.689 30.5115C103.689 29.903 103.859 29.2976 104.197 28.7888C104.856 27.8196 106.068 27.0436 109.475 26.7763L111.288 26.6314V26.3416C111.288 25.1534 111.288 23.1666 108.732 23.1666C107.128 23.1666 106.579 23.9459 106.395 24.6511L104.627 23.9105C104.653 23.8493 104.685 23.7849 104.721 23.7237C105.399 22.4647 106.733 21.6886 108.662 21.6886C109.726 21.6886 111.095 21.9559 111.992 22.6579C113.268 23.6271 113.236 25.5334 113.236 25.5334L113.316 31.4164C113.313 31.4131 113.377 33.1198 113.625 33.6028ZM110.999 30.4375C111.288 29.8063 111.314 29.5423 111.314 27.8679C110.565 27.987 109.552 28.1352 108.318 28.3992C106.193 28.8629 105.83 29.6614 105.83 30.4665C105.83 31.3874 106.556 32.1634 107.98 32.1634C109.308 32.1602 110.443 31.6257 110.999 30.4375ZM47.1158 33.6028L45.1163 33.6124C45.1163 33.6124 44.9427 32.801 44.8881 31.9187C44.3062 32.5208 43.2294 33.7702 41.0563 33.7702C38.8319 33.7702 37.1796 32.4468 37.1796 30.5115C37.1796 29.903 37.3499 29.2976 37.6875 28.7888C38.3465 27.8196 39.5616 27.0436 42.969 26.7763L44.7788 26.6314V26.3416C44.7788 25.1534 44.7788 23.1666 42.2264 23.1666C40.6192 23.1666 40.0759 23.9459 39.8862 24.6511L38.1182 23.9105C38.1472 23.8493 38.1793 23.7849 38.2114 23.7237C38.8929 22.4647 40.2238 21.6886 42.1589 21.6886C43.2165 21.6886 44.5891 21.9559 45.486 22.6579C46.759 23.6271 46.7332 25.5334 46.7332 25.5334L46.8072 31.4164C46.7975 31.4131 46.8683 33.1198 47.1158 33.6028ZM44.4831 30.4375C44.7724 29.8063 44.7981 29.5423 44.7981 27.8679C44.0491 27.987 43.0365 28.1352 41.8021 28.3992C39.6741 28.8629 39.3108 29.6614 39.3108 30.4665C39.3108 31.3874 40.0373 32.1634 41.4646 32.1634C42.7922 32.1602 43.9301 31.6257 44.4831 30.4375Z"
                  fill="#3C1053"/>
                <path
                  d="M126.137 23.9424C125.838 24.1323 125.539 24.3223 125.243 24.5187C121.794 22.5996 114.378 18.8966 113.735 18.5649C113.047 18.2075 111.848 17.7245 111.999 16.5813C112.212 14.9745 114.992 11.4615 116.175 10.0189C122.572 2.18454 125.433 -0.233716 127.336 0.0174477C129.361 0.284711 130.486 2.38096 130.618 12.1989C129.49 11.8479 128.239 11.4872 126.912 11.1556C126.802 9.72909 126.539 7.57811 126.436 6.83106C126.323 5.99385 126.159 5.67184 125.822 5.62998C125.439 5.58168 124.507 6.47685 123.662 7.34304C123.276 7.73911 122.189 8.83714 120.99 10.0479C119.988 9.98348 119.319 10.1928 118.949 10.6822C118.653 11.0783 118.589 11.616 118.766 12.2955C118.117 12.9459 117.561 13.5062 117.207 13.8572C115.873 15.1903 114.465 16.2915 114.391 16.8325C114.333 17.2737 115.008 17.7309 115.969 18.3041C118.316 19.7112 124.093 22.8443 126.137 23.9424ZM135.112 14.1406C132.855 13.3549 127.278 11.2747 121.396 10.4955C119.374 10.2282 118.557 10.9495 119.393 12.8815C120.213 14.7878 122.344 17.9853 124.578 20.3778C126.809 22.7735 129.229 23.4175 129.998 19.7273C130.027 19.5953 130.052 19.4665 130.078 19.3345C130.264 18.3846 130.403 17.4636 130.473 16.6586C129.483 16.2078 128.374 15.728 127.265 15.2579C127.326 16.1048 127.423 17.5667 127.474 18.6905C127.481 18.8354 127.487 18.9771 127.49 19.1091C127.558 20.9316 126.937 20.9252 125.902 20.1846C124.697 19.3216 121.007 14.4336 120.582 12.2761C120.563 12.1345 120.63 12.128 120.701 12.1506C120.727 12.1634 120.759 12.1731 120.794 12.186C120.798 12.186 120.801 12.1892 120.804 12.1892C121.637 12.5177 124.414 13.6157 127.233 14.8039C128.358 15.2804 129.487 15.7667 130.502 16.2271C131.502 16.6779 132.393 17.103 133.058 17.4572C134.276 18.1109 134.749 18.5552 134.238 19.0769C131.701 21.6594 122.845 25.327 119.788 29.8608C119.788 29.8608 119.775 29.8769 119.756 29.9059C119.721 29.9542 119.689 30.0089 119.656 30.0669C119.647 30.083 119.64 30.1023 119.631 30.1184C119.48 30.3953 119.264 30.8783 119.187 31.4644C119.059 32.4562 119.573 33.361 120.994 33.7474C121.351 33.8537 121.756 33.9309 122.199 33.976C122.276 33.9825 122.363 33.9889 122.45 33.9921C125.179 34.1241 132.267 32.5689 134.424 31.6093C136.652 30.6175 135.986 29.6322 135.34 29.1202C134.858 28.7338 132.376 27.3459 131.174 26.6794C130.853 26.8855 130.599 27.0465 130.281 27.2526C132.328 28.5052 133.138 29.1266 133.62 29.4937C133.804 29.6386 133.704 29.8093 133.431 29.8286C133.357 29.835 133.296 29.8415 133.212 29.8447C131.267 29.9799 127.58 30.2375 125.851 30.3309C125.597 30.347 125.311 30.3599 125.153 30.3663C125.581 29.9638 126.063 29.6032 126.301 29.4325C130.001 26.8275 136.166 23.1663 137.983 21.5917C139.32 20.439 142.968 16.8872 135.112 14.1406Z"
                  fill="#F0AB00"/>
              </svg>
              для&nbsp;лікування ХОЗЛ
            </p>
          </div>

          <p class="section2__text2"><b>*Оригінальний (інноваційний) лікарський засіб —</b> <i>лікарський засіб, що був
            уперше у
            світі зареєстрований на основі повного комплекту документів щодо його якості, безпеки та ефективності
            (повної реєстраційної інформації) (визначення з Наказу Міністерства охорони здоров’я України № 460 від
            23.07.2015
            у чинній редакції станом на квітень 2024 року).</i></p>
        </div>
        <div class="section2__col section2__col--second">
          <img src="@/assets/img/pulmonology/section2-img1.png" alt="img">
        </div>

        <div class="section2__decor">
          <img class="section2__decor-item section2__decor-item--item1"
               src="@/assets/img/pulmonology/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item2"
               src="@/assets/img/pulmonology/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item3"
               src="@/assets/img/pulmonology/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item4"
               src="@/assets/img/pulmonology/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item5"
               src="@/assets/img/pulmonology/section2-patern.svg" alt="pattern">
        </div>
      </div>
    </section>

    <section class="section section3">
      <div class="section3__content container">
        <div class="section3__col section3__col--first">
          <h3>Хронічне обструктивне захворювання легень (ХОЗЛ) є однією із найпоширеніших хронічних респіраторних
            хвороб,
            якій зазвичай можна запобігти і лікувати.</h3>
          <p>Для <b>ХОЗЛ</b> характерна наявність запалення в дихальних шляхах, тому основою лікування є призначення
            лікарських засобів із протизапальною місцевою дією. Навіть коли почуваєтеся добре, ваше захворювання нікуди
            не
            зникає.
            Навіть якщо немає жодних неприємних або тяжких відчуттів, запалення в дихальних шляхах все одно
            залишається.<br>
            <b> Від своєчасного і постійного лікування цього запалення залежить успіх лікування захворювання.</b>
          </p>
        </div>
        <div class="section3__col section3__col--second">
          <img src="@/assets/img/pulmonology/section3-img1.png" alt="img">
        </div>
      </div>
    </section>

    <section class="section section4">
      <div class="section4__content container">
        <div class="section4__col section4__col--first">
          <h3>При своєчасному, правильно підібраному, регулярному лікуванні </h3>
          <p>можливо істотно <b>уповільнити прогресування захворювання, зменшити його прояви та обмеження,</b> зумовлені
            хворобою. Знайте, що успіх лікування ХОЗЛ багато в чому залежить від вас. <b class="desk">Вкрай важливо
              дотримуватись
              рекомендацій лікаря:</b></p>
        </div>
        <div class="section4__col section4__col--second">
          <img src="@/assets/img/pulmonology/section4-img1.png" alt="img">
        </div>
      </div>
    </section>

    <section class="section section5">
      <div class="section5__row section5__row--desk container">
        <div class="section5__item">
          <img src="@/assets/img/pulmonology/section5-item1.png" alt="">
          <p class="section5__item-num">I.</p>
          <p class="section5__item-text">Постійно застосовувати рекомендований вам лікарський засіб для підтримувального
            лікування</p>
        </div>
        <div class="section5__item">
          <img src="@/assets/img/pulmonology/section5-item2.png" alt="">
          <p class="section5__item-num">II.</p>
          <p class="section5__item-text">Самостійно не скасовувати його прийом і не змінювати дозування</p>
        </div>
        <div class="section5__item">
          <img src="@/assets/img/pulmonology/section5-item3.png" alt="">
          <p class="section5__item-num">III.</p>
          <p class="section5__item-text">Ви маєте змогу впливати на перебіг свого захворювання та поліпшувати якість
            життя, дотримуючись здорового способу життя, уникаючи провокуючих факторів і приймаючи ліки</p>
        </div>
      </div>

      <div class="container">

        <h3 class="section5__title section5__title--mobile">
          Вкрай важливо дотримуватись рекомендацій лікаря:
        </h3>

        <Swiper :options="swiperOption" class="mySwiper">
          <SwiperSlide class="section5__item slider1">
            <img src="@/assets/img/pulmonology/section5-item1.svg" alt="">
            <p class="section5__item-num">I.</p>
            <p class="section5__item-text">Постійно застосовувати рекомендований вам лікарський засіб для
              підтримувального лікування</p>
          </SwiperSlide>
          <SwiperSlide class="section5__item slider1">
            <img src="@/assets/img/pulmonology/section5-item2.svg" alt="">
            <p class="section5__item-num">II.</p>
            <p class="section5__item-text">Самостійно не скасовувати його прийом і не змінювати дозування</p>
          </SwiperSlide>
          <SwiperSlide class="section5__item slider1">
            <img src="@/assets/img/pulmonology/section5-item3.svg" alt="">
            <p class="section5__item-num">III.</p>
            <p class="section5__item-text">Ви маєте змогу впливати на перебіг свого захворювання та поліпшувати якість
              життя, дотримуючись здорового способу життя, уникаючи провокуючих факторів і приймаючи ліки</p>
          </SwiperSlide>
          <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
      </div>
    </section>

    <section class="section section6">
      <div class="section6__row section6__row--first">
        <div class="container">

          <h2>Учасник, якому лікар призначив відповідний лікарський засіб, може придбати його зі знижкою, користуючись
            карткою учасника програми**</h2>
        </div>
      </div>
      <div class="section6__row section6__row--second ">
        <div class="container">
          <div class="section6__table section6__table--desk">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
                <td class="section6__item-head">Дозування</td>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
              Будесонід<br>
              <span>+</span><br>
              Формотерол<br>
              <span>+</span><br>
              Глікопіроній
                </span>
                </td>
                <td class="section6__item-body">
              <span>
              160 мкг<br><span class="top">+</span><br>5 мкг<br><span class="top">+</span><br>7,2&nbsp;мкг<br><span
                class="mt">в&nbsp;1&nbsp;інгаляції</span>
              </span></td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">50 <span>% </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
              Будесонід<br>
              <span>+</span><br>
              Формотерол<br>
              <span>+</span><br>
              Глікопіроній
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
        160 мкг<br><span class="top">+</span><br>5 мкг<br><span class="top">+</span><br>7,2&nbsp;мкг<br><span
                class="mt">в&nbsp;1&nbsp;інгаляції</span>
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">50 <span>% </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <p class="section6__smallText">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            Умови програми, зокрема розмір знижок, можуть бути змінені без попередження учасників програми.
          </p>
        </div>
      </div>
    </section>

    <section class="section section7">
      <div class="content container">
        <a href="/Terapiaplus_Pulmo_Content_01.pdf" download class="section7__download">
          <p>Завантажити матеріали </p>
        </a>

        <div class="section7__videoWrapper">
          <iframe id="kaltura_player"
                  src="https://cdnapisec.kaltura.com/p/432521/sp/43252100/embedIframeJs/uiconf_id/46292662/partner_id/432521?iframeembed=true&playerId=kaltura_player&entry_id=1_27r9xt5r&flashvars[streamerType]=auto&amp;flashvars[localizationCode]=en&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_04bj9vyu"
                  allowfullscreen webkitallowfullscreen mozAllowFullScreen
                  allow="autoplay *; fullscreen *; encrypted-media *"
                  sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
                  frameborder="0" title="ТерапіяПлюс_Як користуватися доставковим пристроєм Аеросфера?"></iframe>
          <div class="overlay"></div>


        </div>
      </div>

    </section>
  </div>
</template>

<style scoped lang="scss">
.pulmonology {

  &__banner {
    overflow: hidden;
    position: relative;
    height: 396px;
    // padding: 88px 0 308px;
    background: #69b6c7 url("~@/assets/img/pulmonology/patternt.png") no-repeat center calc(100% - 131px);
    background-size: contain;
    background-position-y: bottom;
    z-index: 1;
    @media (max-width: 1024px) {
      background: #69b6c7;
      height: auto;
    }
    //@media (max-width: 768px) {
    //  background-size: unset;
    //}


    &--title {
      font-size: 72px;
      line-height: 80px;
      font-weight: 700;
      color: #fff;
      margin-top: 115px;
      @media (max-width: 1200px) {
        font-size: 56px;
        line-height: 64px;
        margin-top: 40px;
      }
      @media screen and (max-width: 1336px) {
      }
      @media screen and (max-width: 1024px) {

      }
      @media (max-width: 768px) {
        font-size: 48px;
        line-height: 40px;
        padding-left: 20px;
      }
      @media (max-width: 550px) {
        font-size: 32px;

      }

    }
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    //padding-left: 0;
    //padding-right: 0;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
    @media (max-width: 768px) {
      padding-left: 0;
      padding-right: 0;
    }
    @media (max-width: 400px) {
      padding: 0;
    }

    .right {
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: flex-end;


      @media (max-width: 1770px) {
        right: -70px;
      }

      @media (max-width: 1024px) {
        right: 0;
      }

      @media (max-width: 1024px) {
        position: relative;
        right: 0;
      }

      .img-desc {
        width: 100%;
        height: auto;

        @media (max-width: 1770px) {
          max-width: 80%;
        }
        @media (max-width: 768px) {
          display: none;
        }
      }

      .img-mob {
        display: none;
        width: 100%;
        height: auto;
        @media (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    .container {
      padding: 100px 15px 92px 15px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;


      @media screen and (max-width: 1440px) {
        padding: 80px 15px 92px 15px;

      }

      @media screen and (max-width: 1200px) {
        padding: 40px 15px 92px 15px;
      }

      @media screen and (max-width: 1024px) {
        padding: 40px 20px 48px 20px;
        flex-direction: column;
      }
    }

    &__col {

      &--first {
        max-width: 773px;
        width: 100%;
        margin-right: 70px;

        @media (max-width: 1770px) {
          min-width: 773px;
          margin-right: 35px;
        }

        @media (max-width: 1440px) {
          min-width: 598px;
        }

        @media screen and (max-width: 1200px) {
          min-width: 441px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 100%;
          min-width: 0;
          margin-right: 0;
        }
      }

      &--second {
        max-width: 606px;
        width: 100%;
        margin-right: 180px;

        @media screen and (max-width: 1770px) {
          margin-right: 80px;
        }

        @media (max-width: 1440px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1200px) {
        }

        @media screen and (max-width: 1024px) {
          max-width: 480px;
          margin: 40px auto 0 auto;
        }

        img {
          width: 100%;
          height: auto;
          display: block;

          @media screen and (max-width: 1024px) {
            padding: 0 40px;
          }
        }
      }
    }

    h3 {
      color: var(--Purple, #3C1053);

      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 64px;

      @media (max-width: 1440px) {
        font-size: 38px;
        line-height: 120%;
      }

      @media screen and (max-width: 1200px) {
        font-size: 28px;
        line-height: 120%;
      }

      @media screen and (max-width: 1024px) {
        font-size: 32px;
        line-height: 40px;
        br {
          display: none;
        }
      }

      span {
        color: #69B6C7;

        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        @media (max-width: 1440px) {
          font-size: 38px;
          line-height: 120%;
        }

        @media screen and (max-width: 1200px) {
          font-size: 28px;
          line-height: 120%;
        }

        @media screen and (max-width: 1024px) {
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 24px;
        }

      }
    }

    &__iconText {
      display: flex;
      align-items: center;
      margin-top: 56px;
      @media screen and (max-width: 1024px) {
        margin-top: 24px;
        flex-direction: column;
        align-items: flex-start;
      }

      > svg {
        margin-right: 50px;
        width: 96px;
        min-width: 96px;
        height: auto;
        display: block;

        @media (max-width: 1400px) {
          margin-right: 25px;
        }


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          margin-bottom: 8px;

          width: 68px;
          min-width: 68px;
        }
      }
    }

    &__text1 {
      max-width: 373px;
      width: 100%;
      color: var(--Purple, #3C1053);
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;


      @media (max-width: 1200px) {
        font-size: 20px;
      }

      @media screen and (max-width: 1024px) {
        line-height: 40px;
        font-size: 20px;
        max-width: 280px;
      }

      svg {
        line-height: 0;
        width: 140px;
        height: auto;
        display: inline-block;
        margin-top: -7px;
      }
    }

    &__text2 {
      max-width: 613px;
      margin-top: 44px;
      color: var(--Purple, #3C1053);

      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */

      @media screen and (max-width: 1024px) {
        margin-top: 24px;
        max-width: 100%;
      }

      b {
        font-weight: 600;
        color: var(--Purple, #3C1053);

      }

      i {
        color: var(--Purple, #3C1053);
        font-weight: 400;
        font-style: italic;
      }
    }

    &__decor {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      pointer-events: none;

      @media screen and (max-width: 1024px) {
        display: none;
      }

      &-item {
        width: 163px;
        height: auto;
        display: block;
        position: absolute;

        @media screen and (max-width: 1770px) {
          //width: 140px;
        }
        @media screen and (max-width: 1440px) {
          width: 130px;
        }
        @media screen and (max-width: 1200px) {
          width: 80px;
        }

        &--item1 {
          top: 47%;
          transform: translateY(-50%);
          left: -135px;

          @media screen and (max-width: 1770px) {
            left: -120px;
            top: 46%;
          }
          @media screen and (max-width: 1440px) {
            left: -110px;
            top: 40.4%;
          }

          @media screen and (max-width: 1200px) {
            left: -60px;
            top: 28.4%;
          }
        }

        &--item2 {
          top: 41%;
          left: 49.3%;
          transform: translate(-50%, -50%);

          @media screen and (max-width: 1770px) {
            top: 44%;
            left: 54.9%;
          }

          @media screen and (max-width: 1440px) {
            top: 41%;
            left: 51.1%;
          }

          @media screen and (max-width: 1200px) {
            top: 39%;
            left: 47.5%;
          }
        }

        &--item3 {
          top: 62%;
          left: 41.7%;
          transform: translate(-50%, -50%);
          @media screen and (max-width: 1770px) {
            top: 65%;
            left: 45.5%;
          }
          @media screen and (max-width: 1440px) {
            top: 60%;
            left: 45.2%;
          }
          @media screen and (max-width: 1200px) {
            top: 52%;
            left: 43%;
          }
        }

        &--item4 {

          top: 72.3%;
          left: 53.9%;
          transform: translate(-50%, -50%);

          @media screen and (max-width: 1770px) {
            top: 75.1%;
            left: 60.9%;
          }
          @media screen and (max-width: 1440px) {
            top: 69.3%;
            left: 59.9%;
          }
          @media screen and (max-width: 1200px) {
            top: 58.2%;
            left: 53.9%;
          }
        }

        &--item5 {
          right: -120px;
          bottom: 92px;
        }
      }
    }
  }

  .section3 {
    background: rgba(105, 182, 199, 0.1);

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin: 0 auto;
      padding: 150px 0 0 0;

      @media screen and (max-width: 1024px) {
        padding: 48px 20px 48px 20px;
        flex-direction: column;
      }

    }

    &__col {

      &--first {
        max-width: 911px;
        width: 100%;
        margin-right: 70px;

        @media (max-width: 1440px) {
          margin-right: 80px;
        }
        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          margin-right: 0;
        }

        h3 {
          color: var(--Purple, #3C1053);

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          max-width: 770px;
          width: 100%;

          @media (max-width: 1440px) {
            font-size: 38px;
            line-height: 120%;
          }

          @media screen and (max-width: 1200px) {
            font-size: 28px;
            line-height: 120%;
          }

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            font-size: 32px;
            line-height: 40px;
          }
        }

        p {
          margin-top: 70px;
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 0;

          @media (max-width: 1440px) {
            font-size: 20px;
            line-height: 140%;
            margin-top: 53px;
          }
          @media screen and (max-width: 1200px) {
            font-size: 18px;
            margin-top: 35px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 18px;
            line-height: 28px;
            margin-top: 20px;
          }


          b {
            font-weight: 700;
            margin-top: 10px;
            display: inline-block;

          }
        }
      }

      &--second {
        max-width: 352px;
        width: 100%;
        margin-right: 208px;


        @media screen and (max-width: 1770px) {
          margin-right: 90px;
          max-width: 320px;
        }

        @media (max-width: 1440px) {
          max-width: 300px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 480px;
          margin-top: 40px;
          margin-right: 0;
        }

        img {
          width: 100%;
          height: auto;
          display: block;
          @media screen and (max-width: 1024px) {
            padding: 0 40px;
          }
        }
      }
    }
  }

  .section4 {
    background: rgba(105, 182, 199, 0.1);

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 150px 0 0 0;

      @media screen and (max-width: 1024px) {
        padding: 48px 20px 48px 20px;
        flex-direction: column;
      }

    }

    &__col {

      &--first {
        max-width: 920px;
        width: 100%;
        margin-right: 120px;

        @media (max-width: 1440px) {
          margin-right: 80px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          margin-right: 0;
        }

        h3 {
          color: var(--Purple, #3C1053);

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            font-size: 38px;
            line-height: 120%;
          }

          @media screen and (max-width: 1200px) {
            font-size: 28px;
            line-height: 120%;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            line-height: 40px;
          }
        }

        p {
          margin-top: 45px;
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 0;

          max-width: 742px;
          width: 100%;

          @media (max-width: 1440px) {
            font-size: 20px;
            line-height: 140%;
          }
          @media screen and (max-width: 1200px) {
            font-size: 18px;
            margin-top: 35px;
          }

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            font-size: 18px;
            line-height: 28px;
            margin-top: 20px;
          }

          b {
            font-weight: 700;

            &.desk {
              @media screen and (max-width: 1024px) {
                display: none;
              }
            }
          }
        }
      }

      &--second {
        max-width: 352px;
        width: 100%;
        margin-right: 197px;

        @media screen and (max-width: 1770px) {
          margin-right: 90px;
          max-width: 320px;
        }


        @media (max-width: 1440px) {
          max-width: 300px;
        }


        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 480px;
          margin-top: 40px;
          margin-right: 0;
          padding: 0 40px;


        }

        img {
          width: 100%;
          height: auto;
          display: block;

        }
      }
    }
  }

  .section5 {
    background: rgba(105, 182, 199, 0.1);

    &__row {

      max-width: 1920px;
      padding: 150px 0 150px 0;

      display: grid;

      grid-gap: 160px;

      grid-template-columns: 1fr 1fr 1fr;
      @media screen and (max-width: 1700px) {
        grid-gap: 140px;
      }
      @media screen and (max-width: 1445px) {
        grid-gap: 100px;
      }
      @media screen and (max-width: 1350px) {
        grid-gap: 60px;
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }
    }

    &__item {

      display: flex;
      flex-direction: column;

      &-num {
        color: #70C2D4;

        font-size: 72px;
        font-style: normal;
        font-weight: 700;
        line-height: 88px; /* 122.222% */

        margin-top: -88px;
        margin-bottom: 8px;

        @media (max-width: 1440px) {
          font-size: 62px;
        }
        @media screen and (max-width: 1200px) {
          font-size: 58px;
        }
        @media screen and (max-width: 1024px) {
          font-size: 52px;
        }
      }

      &-text {
        color: var(--Purple, #3C1053);

        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        @media (max-width: 1440px) {
          font-size: 22px;
          line-height: 140%;
        }
        @media screen and (max-width: 1200px) {
          font-size: 20px;
        }

        @media screen and (max-width: 1024px) {
          font-size: 20px;
          line-height: 28px; /* 140% */
        }
      }

      img {
        margin: 0 0 0 auto;
        max-width: 75%;
        width: 100%;
        height: auto;

        display: block;

        @media screen and (max-width: 1350px) {
          max-width: 200px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 70%;
        }


        @media screen and (max-width: 340px) {
          max-width: 200px;
        }
      }
    }

    .mySwiper {
      display: none;
      //max-width: 480px;
      margin: 0 auto;
      //padding-bottom: 40px;
      padding: 0 0 80px 0;
      @media screen and (max-width: 1024px) {
        display: block;
      }

      ::v-deep(.swiper-pagination-bullet) {
        border: 1px solid #63B3CD;
        background: white;
        opacity: 1;
        bottom: 48px;

        &.swiper-pagination-bullet-active {
          background: #63B3CD;
          width: 8px;
          height: 8px;
        }
      }
    }

    &__title {
      color: var(--Purple, #3C1053);

      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      margin-bottom: 32px;

      &--mobile {

        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }
    }
  }

  .section6 {

    &__row {

      &--first {
        padding: 150px 0 220px 0;

        background: url("~@/assets/img/pulmonology/section6-bg.png") #FFEEC3 repeat-x left top;
        background-size: contain;


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          padding: 48px 20px 100px 20px;

          background: url("~@/assets/img/pulmonology/section6-bg.png") #FFEEC3 repeat-x left top;
          background-size: cover;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }

        h2 {
          color: var(--Purple, #3C1053);
          text-align: center;
          width: 80%;
          margin: 0 auto;

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            width: 100%;
            font-size: 42px;
            line-height: 52px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            width: 100%;
            line-height: 40px; /* 125% */
            text-align: left;
          }
        }
      }

      &--second {
        background: #69B6C7;
        padding: 0 0 220px 0;


        @media screen and (max-width: 1024px) {
          padding: 0 20px 48px 20px;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    &__table {

      width: 100%;
      margin: 0 auto 0 auto;
      top: -120px;
      position: relative;

      @media screen and (max-width: 1024px) {
        top: -60px;
      }

      &--mob {
        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px dashed #FFF;

        @media screen and (max-width: 1024px) {
          margin-bottom: 12px;
        }

        td {
          width: calc(100% / 3);
          @media screen and (max-width: 1024px) {
            width: 100%;

          }
        }
      }
    }

    &__item {
      //height: fit-content;

      &-head {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        //border-top: 1px dashed #FFF;
        border-left: 1px dashed #FFF;
        background: #69B6C7;
        margin-bottom: 0;
        padding: 32px 20px;
        text-align: center;

        &--first {
          border-left: none;
        }

        @media screen and (max-width: 1024px) {
          line-height: 36px;
          font-size: 16px;

          padding: 2px 20px;
          //border-top: 1px dashed #FFF;
          //border-left: 1px dashed #FFF;
          //border-right: 1px dashed #FFF;
        }

        &--last {
          //border-right: 1px dashed #FFF;
        }
      }

      &-body {
        border-top: 1px dashed #69B6C7;
        border-left: 1px dashed #69B6C7;
        //border-bottom: 1px dashed #69B6C7;
        background: var(--White, #FFF);

        padding: 70px 20px;
        height: 100%;
        text-align: center;

        @media screen and (max-width: 1024px) {
          border-left: none;
          padding: 35px 20px;
          height: 268px;
        }

        > span {
          color: var(--Purple, #3C1053);
          font-size: 34px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 105.882% */

          .mt {
            color: var(--Purple, #3C1053);
            font-size: 34px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px;

            display: inline-block;

            padding-top: 20px;

            @media screen and (max-width: 1024px) {
              font-size: 24px;
              line-height: 36px;
            }
          }

          span {
            color: #69B6C7;
            font-size: 44px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px; /* 81.818% */

            &.top {
              position: relative;
              top: 4px;
              //@media screen and (max-width: 1024px) {
              //  top: 10px;
              //}
            }

            @media screen and (max-width: 1024px) {
              font-size: 44px;
              line-height: 36px;
            }

            &.big {
              color: #69B6C7;
              font-size: 58px;
              font-style: normal;
              font-weight: 700;
              line-height: 64px; /* 110.345% */

              @media screen and (max-width: 1024px) {
                font-size: 58px;
                line-height: 64px;
              }

              span {
                font-size: 42px;
                line-height: 40px; /* 95.238% */

              }
            }
          }

          @media screen and (max-width: 1024px) {
            font-size: 24px;
            line-height: 36px;
          }
        }

        &--last {
          //border-right: 1px dashed #69B6C7;
        }

        &--first {
          border-left: none;
        }
      }

    }

    &__smallText {
      max-width: 1680px;
      width: 100%;
      margin: -80px auto 0 auto;

      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;

      @media screen and (max-width: 1024px) {
        margin: -40px auto 0 auto;
        font-size: 14px;
      }

      svg {
        width: 8px;
        height: auto;
        display: inline-block;
        position: relative;
        top: -2px;
        margin-right: 8px;

        &:first-child {
          margin-right: 0;
        }
      }
    }
  }

  .section7 {

    background: rgba(105, 182, 199, 0.1);


    .content {

      padding: 100px 0 150px 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      @media screen and (max-width: 1024px) {
        padding: 60px 20px 48px 20px;
      }

    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;

      text-decoration: none;
      border-radius: 2px;
      border: 1px solid var(--Purple, #3C1053);
      background: #70C2D4;
      padding: 24px 44px;
      margin-bottom: 100px;
      @media screen and (min-width: 1024px) {
        &:hover {
          background: #C4D600;
        }
      }

      &:active {
        background: #C4D600;
      }

      @media screen and (max-width: 1024px) {
        margin-bottom: 60px;
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.26px;
        text-transform: uppercase;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
          letter-spacing: 0.98px;
        }
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      pointer-events: none;
      z-index: 10;
    }

    &__videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      width: 100%;
      height: 0;
      overflow: hidden;


      iframe {
        position: absolute;
        z-index: 20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>